/**
 * Checks if the current view is being loaded in an iframe.
 *
 * @returns {boolean}
 */
const inIframe = () => {
  if (!window) {
    return false;
  }

  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

export default inIframe;
